<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        dashboard
    </div>
</div>